import { render, staticRenderFns } from "./ClaimSubmitterDetails.vue?vue&type=template&id=5c6550cb&scoped=true"
import script from "./ClaimSubmitterDetails.vue?vue&type=script&lang=js"
export * from "./ClaimSubmitterDetails.vue?vue&type=script&lang=js"
import style0 from "./ClaimSubmitterDetails.vue?vue&type=style&index=0&id=5c6550cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6550cb",
  null
  
)

export default component.exports